import { request } from "./request";
import Cookies from "js-cookie";
import { USER_ID_COOKIES_KEY, USER_TOKEN_COOKIES_KEY, AD_ID_COOKIES_KEY } from "@/utils/constant";
import { getAppID, getFbPixelId, getTtPixelId, isTtChannel, setUserInfo, COS_IMG_ADDRESS } from '@/utils/base'
import { getParam, setStorage, getStorage } from '@/utils/tools'
import { getRandomString } from "@/utils/paypal";
import { Toast } from 'vant'
import cos from '@/utils/cos'
import { toast, closeToast } from '@/components/pay/toast.js'
import loadImage from 'blueimp-load-image'

export const fetchGetTmpUuid = function (data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/api/v1/user/tmp_register",
      method: "post",
      isToast: false,
      data: {
        app_id: getAppID(),
        user_type: 0
      },
    }).then(response => {
      setUserInfo(response.token_info.user_id, response.token_info.accessToken)
      // Cookies.set(USER_ID_COOKIES_KEY, response.token_info.user_id, { expires: 365 })
      // Cookies.set(USER_TOKEN_COOKIES_KEY, response.token_info.accessToken, { expires: 365 })

      setStorage(USER_ID_COOKIES_KEY, response.token_info.user_id)
      setStorage(USER_TOKEN_COOKIES_KEY, response.token_info.accessToken)
      resolve(response)
    })
  })
}

export const fetchRegister = function (data) {
  return request({
    url: "/api/v1/user/register",
    method: "post",
    data,
  })
}

export const fetchLogin = function (data) {
  return request({
    url: "/api/v1/user/login",
    method: "post",
    data,
  })
}



// 获取档位列表
export const fetchGearList = function (data, isLoading = true) {
  return request({
    url: "/api/v1/order/purchase_list",
    method: "post",
    data,
    isToast: isLoading,
  })
}


export const fetchOrderSubmit = function (data) {
  return request({
    url: "/api/v1/alipay/submit",
    method: "post",
    isToast: false,
    responseType: 'all',
    data: {
      cid: getParam('pid') || '130500',
      cmid: getRandomString(),
      ...data,
    },
  })
}

export const fetchPaypalAppleCapture = function (data) {
  return request({
    url: '/api/v1/order/applepaypalcapture',
    method: 'post',
    data: {
      cmid: getRandomString(),
      ...data,
    },
  })
}

export const fetchGetUserDetail = function (data) {
  return request({
    url: "/api/v1/user/detail",
    method: "post",
    isToast: false,
    isClearToast: 'none',
    data,
  })
}

export const fetchPixelReport = function (data, type = '') {
  if (isTtChannel()) {
    fetchTtReport(data, type)
  } else {
    fetchFbReport(data, type)
  }
}


export const fetchFbReport = function (data, type = '') {
  const obj = {
    app_id: getAppID(),
    lan: window.navigator.language,
    ts: new Date().getTime(), // int
    event: 'pixel_report',
    project: "",
    cid: getParam('pid') || '',
    time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    properties: {
      fbid: getFbPixelId(),
      ip: "",
      client_user_agent: window.navigator.userAgent,
      event_source_url: window.location.href,
      fbp: Cookies.get('_fbp') || "",
      fbc: Cookies.get('_fbc') || "",
    },
    ...data
  }
  console.log('PageView', getFbPixelId())
  window.fbq('init', getFbPixelId());
  window.fbq('track', 'PageView');

  return request({
    url: "/api/v1/report/fb",
    method: "post",
    isToast: false,
    data: {
      ...obj
    },
  })
}

export const fetchTtReport = function (data, type = '') {
  const obj = {
    app_id: getAppID(),
    lan: window.navigator.language,
    ts: new Date().getTime(), // int
    event: 'pixel_report',
    project: "",
    cid: getParam('pid') || '',
    time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    properties: {
      ttid: getTtPixelId(),
      ip: "",
      client_user_agent: window.navigator.userAgent,
      event_source_url: window.location.href,
      ttclid: Cookies.get('ttclid') || "",
      ttp: Cookies.get('_ttp') || "",
    },
    ...data
  }
  if (obj.event === 'pixel_report') {
    if (type === 'PageView') {
      console.log('PageViewTT', getTtPixelId())
      window.ttq.track('PageView');
    }
  }

  return request({
    url: "/api/v1/report/tt",
    method: "post",
    isToast: false,
    data: {
      ...obj
    },
  })
}


// 埋点统计上报
export const fetchReportEvent = function (data) {
  return request({
    url: "/api/v1/data/receive",
    method: "post",
    isToast: false,
    data: {
      app_id: getAppID(),
      user_id: Cookies.get(USER_ID_COOKIES_KEY) || '',
      idfp: Cookies.get(AD_ID_COOKIES_KEY) || '', // 传 ad_id
      ...data
    },
  })
}

export const fetchCosTempCredential = function () {
  return request({
    url: "/api/v1/image/temp_credential",
    method: "post",
    isToast: false,
    isClearToast: 'none',
  })
}


export const fetchCosUpload = async function (file) {
  try {
    // toast('')
    return new Promise((resolve, reject) => {
      loadImage(
        file,
        (canvas) => {
          console.log(canvas)
          canvas.toBlob(async (blob) => {
            const randomString = (Math.random().toFixed('8') + '').slice(2)
            // 获取文件后缀
            const suffix = file.name.substring(file.name.lastIndexOf(".") + 1);
            // ✅ 生成修正后的图像文件再上传
            const data = await cos.uploadFile({
              Bucket: 'novel-1340728365', // 填写自己的 bucket，必须字段
              Region: 'na-siliconvalley',     // 存储桶所在地域，必须字段
              Key: `${COS_IMG_ADDRESS}${Date.now()}-${randomString}.${suffix}`,            // 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段
              Body: blob, // 上传文件对象
              SliceSize: 1024 * 1024 * 5,  // 触发分块上传的阈值，超过5MB 使用分块上传，小于5MB使用简单上传。可自行设置，非必须
              onProgress: function (progressData) {
                console.log('上传进度：', progressData);
              },
            });
            // closeToast()
            resolve(data)
          }, file.type)
        },
        { orientation: true, canvas: true }
      )
    })


  } catch (e) {
    console.error('上传失败', e);
    closeToast()
  } finally {
  }
}



export const fetchHomeTplList = function (data) {
  return request({
    url: "/api/v1/aivideo/home_tpl_list",
    method: "post",
    isToast: false,
    data: {
      page: 1,
      size: 100,
      ...data
    },
  })
}

export const fetchTplList = function (data) {
  return request({
    url: "/api/v1/aivideo/tpl_list",
    method: "post",
    isToast: false,
    data
  })
}

export const fetchHairstyleGet = function (data) {
  return request({
    url: "/api/v1/aivideo/face_merge_get",
    method: "post",
    isToast: false,
    data,
  })
}

export const fetchFeedback = function (data) {
  return request({
    url: "/api/v1/user/feedback",
    method: "post",
    isToast: true,
    data,
  })
}

export const fetchFaceMerge = function(data){
  return request({
    url: "/api/v1/aivideo/face_merge",
    method: "post",
    isToast: false,
    data,
  })
}
